let sortOrder = 'asc'; // Estado de orden, 'asc' o 'desc'

function sortTable(column) {
    const table = document.querySelector('.table tbody');
    const rows = Array.from(table.rows);
    const isAsc = sortOrder === 'asc';

    // Ordenar las filas
    rows.sort((a, b) => {
        const aText = a.querySelector(`.column-${column}`).textContent.trim();
        const bText = b.querySelector(`.column-${column}`).textContent.trim();

        return isAsc ? aText.localeCompare(bText) : bText.localeCompare(aText);
    });

    // Alternar el orden para la próxima vez
    sortOrder = isAsc ? 'desc' : 'asc';

    // Vaciar la tabla y agregar las filas ordenadas
    table.innerHTML = '';
    rows.forEach(row => table.appendChild(row));
}



jQuery(function() {
    jQuery('.component-datepicker.default').datepicker({
        autoclose: true,
        startDate: 'today',
    });

    jQuery('.component-datepicker.today').datepicker({
        autoclose: true,
        startDate: 'today',
        todayHighlight: true
    });

    jQuery('.component-datepicker.past-enabled').datepicker({
        autoclose: true,
    });

    jQuery('.component-datepicker.format').datepicker({
        autoclose: true,
        format: 'dd-mm-yyyy',
    });

    jQuery('.component-datepicker.autoclose').datepicker();

    jQuery('.component-datepicker.disabled-week').datepicker({
        autoclose: true,
        daysOfWeekDisabled: '0'
    });

    jQuery('.component-datepicker.highlighted-week').datepicker({
        autoclose: true,
        daysOfWeekHighlighted: '0'
    });

    jQuery('.component-datepicker.mnth').datepicker({
        autoclose: true,
        minViewMode: 1,
        format: 'mm/yy'
    });

    jQuery('.component-datepicker.multidate').datepicker({
        multidate: true,
        multidateSeparator: ' , '
    });

    jQuery('.component-datepicker.input-daterange').datepicker({
        autoclose: true
    });

    jQuery('.component-datepicker.inline-calendar').datepicker();

});

// Collapse Sidebar Header
document.addEventListener('DOMContentLoaded', function() {
    const btn = document.getElementById('collapse-sidebar-btn');
    const body = document.body;

    // 1. LEER: Al cargar la página, verificamos el estado guardado
    const isCollapsed = localStorage.getItem('sidebar-collapsed');
    
    if (isCollapsed === 'true') {
        body.classList.add('header-collapsed');
    }

    if (!btn) return;

    // 2. GUARDAR: Al hacer clic, actualizamos el estado
    btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        body.classList.toggle('header-collapsed');
        
        // Guardamos el estado actual (true o false)
        const currentStatus = body.classList.contains('header-collapsed');
        localStorage.setItem('sidebar-collapsed', currentStatus);
        
        // Notificar a otros elementos (como DataTables o Mapas) que el ancho cambió
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    });
});

function applyQboSorting(table) {
    jQuery(table.table().header())
        .find('th')
        .each(function () {
            const th = jQuery(this);

            if (!th.find('.th-label').length) {
                th.wrapInner('<span class="th-label"></span>');
            }
        });
}
